export default __webpack_public_path__ + "static/media/hammam.49755444.jpg";